import CLIENT from '../utils/restClient';
import Logger, { LOG_LEVELS, ALL_MESSAGES } from '../utils/logger';
import { ErrorWarningAction, FilingTypeEnum } from '../utils/enums';
import _ from 'underscore'
import moment from "moment";
import toCsv from '../utils/toCsv';
import FileSaver from 'file-saver';
import { ErrorsWarningsConfig } from '../utils/appConfig';
import { sanitizeCsvData } from '../utils/csvSanitizer';
import LANGUAGES_CONTROLLER, { DEFAULT_LANGUAGE_STRINGS } from './languages';

export const MODULE_NAME = 'ERRORS_WARNINGS_CONTROLLER';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
  return MODULE_NAME + '.' + name;
}

const UNLOAD = namespaced('UNLOAD');
const LOAD = namespaced('LOAD');
const LOAD_ERRORS = namespaced('LOAD_ERRORS');
const LOAD_ERRORS_OK = namespaced('LOAD_ERRORS_OK');
const LOAD_ERRORS_FAIL = namespaced('LOAD_ERRORS_FAIL');
const LOAD_WARNINGS = namespaced('LOAD_WARNINGS');
const LOAD_WARNINGS_OK = namespaced('LOAD_WARNINGS_OK');
const LOAD_WARNINGS_FAIL = namespaced('LOAD_WARNINGS_FAIL');
const LOAD_ERROR_CATEGORIES = namespaced('LOAD_ERROR_CATEGORIES');
const LOAD_ERROR_CATEGORIES_OK = namespaced('LOAD_ERROR_CATEGORIES_OK');
const LOAD_ERROR_CATEGORIES_FAIL = namespaced('LOAD_ERROR_CATEGORIES_FAIL');
const LOAD_ERROR_SUB_CATEGORIES = namespaced('LOAD_ERROR_SUB_CATEGORIES');
const LOAD_ERROR_SUB_CATEGORIES_OK = namespaced('LOAD_ERROR_SUB_CATEGORIES_OK');
const LOAD_ERROR_SUB_CATEGORIES_FAIL = namespaced('LOAD_ERROR_SUB_CATEGORIES_FAIL');
const LOAD_WARNING_CATEGORIES = namespaced('LOAD_WARNING_CATEGORIES');
const LOAD_WARNING_CATEGORIES_OK = namespaced('LOAD_WARNING_CATEGORIES_OK');
const LOAD_WARNING_CATEGORIES_FAIL = namespaced('LOAD_WARNING_CATEGORIES_FAIL');
const LOAD_WARNING_SUB_CATEGORIES = namespaced('LOAD_WARNING_SUB_CATEGORIES');
const LOAD_WARNING_SUB_CATEGORIES_OK = namespaced('LOAD_WARNING_SUB_CATEGORIES_OK');
const LOAD_WARNING_SUB_CATEGORIES_FAIL = namespaced('LOAD_WARNING_SUB_CATEGORIES_FAIL');
const SET_SELECTION = namespaced('SET_SELECTION');
const ACTION = namespaced('ACTION');
const ACTION_PROGRESS = namespaced('ACTION_PROGRESS');
const ACTION_OK = namespaced('ACTION_OK');
const ACTION_FAIL = namespaced('ACTION_FAIL');
const LOAD_NODE_WIZARD_NODES_OK = namespaced('LOAD_NODE_WIZARD_NODES_OK');
const LOAD_NODE_WIZARD_NODES_FAIL = namespaced('LOAD_NODE_WIZARD_NODES_FAIL');
const CLEAR_ERRORS_AND_WARNINGS = namespaced('CLEAR_ERRORS_AND_WARNINGS');
const DOWNLOAD_ERRORS = namespaced('DOWNLOAD_ERRORS');
const DOWNLOAD_WARNINGS = namespaced('DOWNLOAD_WARNINGS');
const DOWNLOAD_ERRORS_OK = namespaced('DOWNLOAD_ERRORS_OK');
const DOWNLOAD_WARNINGS_OK = namespaced('DOWNLOAD_WARNINGS_OK');
const DOWNLOAD_ERRORS_FAIL = namespaced('DOWNLOAD_ERRORS_FAIL');
const DOWNLOAD_WARNINGS_FAIL = namespaced('DOWNLOAD_WARNINGS_FAIL');

const ERROR_ACTION_MOVE = ErrorWarningAction.ERROR_ACTION_MOVE.value;
const ERROR_ACTION_VATRATE = ErrorWarningAction.ERROR_ACTION_VATRATE.value;
const ERROR_ACTION_INVNR = ErrorWarningAction.ERROR_ACTION_INVNR.value;
const ERROR_ACTION_SUPINVNR = ErrorWarningAction.ERROR_ACTION_SUPINVNR.value;
const ERROR_ACTION_VATNR = ErrorWarningAction.ERROR_ACTION_VATNR.value;
const ERROR_ACTION_DELETE = ErrorWarningAction.ERROR_ACTION_DELETE.value;
const ERROR_ACTION_MOVE_WARNING_TO_ERROR = ErrorWarningAction.ERROR_ACTION_MOVE_WARNING_TO_ERROR.value;
const ERROR_ACTION_SAVE_TO_FILE = ErrorWarningAction.ERROR_ACTION_SAVE_TO_FILE.value;
const ERROR_ACTION_OSS_VATNR = ErrorWarningAction.ERROR_ACTION_OSS_VATNR.value;

const GET_REOPENABLE_CLOSED_RETURNS_OK = namespaced('GET_REOPENABLE_CLOSED_RETURNS_OK');
const GET_REOPENABLE_CLOSED_RETURNS_FAIL = namespaced('GET_REOPENABLE_CLOSED_RETURNS_FAIL');
const EXPORT_ALL = namespaced('EXPORT_ALL');
const EXPORT_ALL_OK = namespaced('EXPORT_ALL_OK');
const EXPORT_ALL_FAIL = namespaced('EXPORT_ALL_FAIL');

export const ACTION_TYPES = {
  UNLOAD,
  LOAD,
  LOAD_ERRORS,
  LOAD_ERRORS_OK,
  LOAD_ERRORS_FAIL,
  LOAD_WARNINGS,
  LOAD_WARNINGS_OK,
  LOAD_WARNINGS_FAIL,
  ACTION,
  ACTION_PROGRESS,
  ACTION_OK,
  ACTION_FAIL,
  LOAD_NODE_WIZARD_NODES_OK,
  LOAD_NODE_WIZARD_NODES_FAIL,
  CLEAR_ERRORS_AND_WARNINGS,
  LOAD_ERROR_CATEGORIES,
  LOAD_ERROR_CATEGORIES_OK,
  LOAD_ERROR_CATEGORIES_FAIL,
  LOAD_ERROR_SUB_CATEGORIES,
  LOAD_ERROR_SUB_CATEGORIES_OK,
  LOAD_ERROR_SUB_CATEGORIES_FAIL,
  LOAD_WARNING_CATEGORIES,
  LOAD_WARNING_CATEGORIES_OK,
  LOAD_WARNING_CATEGORIES_FAIL,
  LOAD_WARNING_SUB_CATEGORIES,
  LOAD_WARNING_SUB_CATEGORIES_OK,
  LOAD_WARNING_SUB_CATEGORIES_FAIL,
  SET_SELECTION,
  DOWNLOAD_ERRORS,
  DOWNLOAD_WARNINGS,
  DOWNLOAD_ERRORS_OK,
  DOWNLOAD_WARNINGS_OK,
  DOWNLOAD_ERRORS_FAIL,
  DOWNLOAD_WARNINGS_FAIL,
  GET_REOPENABLE_CLOSED_RETURNS_OK,
  GET_REOPENABLE_CLOSED_RETURNS_FAIL,
  EXPORT_ALL,
  EXPORT_ALL_OK,
  EXPORT_ALL_FAIL
};

export const updateSubStateFromAction = (state = { asList: undefined, asStructure: undefined, loading: false, error: null }, action) => {
  log.debug('updateSubStateFromAction: ', action, state);
  const getNewState = (action, state) => {
    switch (action.type) {
      case UNLOAD:
        if (_.isEmpty(action.dataName)) {
          return Object.assign({}, state, {
            loading: false,
            error: null,
            errorCategories: null,
            errorSubCategories: null,
            warningCategories: null,
            warningSubCategories: null,
            nodeWizardNodes: null,
            transactionErrors: null,
            transactionWarnings: null,
            downloadedTransactionErrors: null,
            downloadedTransactionWarnings: null,
            selection: null
          });
        } else {
          let resetObj = {};
          resetObj[action.dataName] = null;
          return Object.assign({}, state, {
            loading: false,
            error: null,
            asList: null,
            asStructure: null,
          }, resetObj);
        }

      case LOAD:
      case LOAD_ERRORS:
      case LOAD_WARNINGS:
      case LOAD_ERROR_CATEGORIES:
      case LOAD_ERROR_SUB_CATEGORIES:
      case LOAD_WARNING_CATEGORIES:
      case LOAD_WARNING_SUB_CATEGORIES:
      case DOWNLOAD_ERRORS:
      case DOWNLOAD_WARNINGS:
        return Object.assign({}, state, { loading: true, error: null });
      case LOAD_ERRORS_OK:
        return Object.assign({}, state, action.response, { transactionErrors: action.response, loading: false, error: null });
      case LOAD_ERRORS_FAIL:
        return Object.assign({}, state, { transactionErrors: undefined, loading: false, error: action.error });
      case LOAD_WARNINGS_OK:
        return Object.assign({}, state, action.response, { transactionWarnings: action.response, loading: false, error: null });
      case LOAD_WARNINGS_FAIL:
        return Object.assign({}, state, { transactionWarnings: undefined, loading: false, error: action.error });
      case DOWNLOAD_ERRORS_OK:
        return Object.assign({}, state, action.response, { downloadedTransactionErrors: action.response, loading: false, error: null });
      case DOWNLOAD_ERRORS_FAIL:
        return Object.assign({}, state, { downloadedTransactionErrors: undefined, loading: false, error: action.error });
      case DOWNLOAD_WARNINGS_OK:
        return Object.assign({}, state, action.response, { downloadedTransactionWarnings: action.response, loading: false, error: null });
      case DOWNLOAD_WARNINGS_FAIL:
        return Object.assign({}, state, { downloadedTransactionWarnings: undefined, loading: false, error: action.error });
      case LOAD_ERROR_CATEGORIES_OK:
        return Object.assign({}, state, action.response, { errorCategories: action.response, loading: false, error: null });
      case LOAD_ERROR_CATEGORIES_FAIL:
        return Object.assign({}, state, { loading: false, error: action.error, errorCategories: undefined });
      case LOAD_ERROR_SUB_CATEGORIES_OK:
        return Object.assign({}, state, action.response, { errorSubCategories: action.response, loading: false, error: null });
      case LOAD_ERROR_SUB_CATEGORIES_FAIL:
        return Object.assign({}, state, { loading: false, error: action.error, errorSubCategories: undefined });
      case LOAD_WARNING_CATEGORIES_OK:
        return Object.assign({}, state, action.response, { warningCategories: action.response, loading: false, error: null });
      case LOAD_WARNING_CATEGORIES_FAIL:
        return Object.assign({}, state, { loading: false, error: action.error, warningCategories: undefined });
      case LOAD_WARNING_SUB_CATEGORIES_OK:
        return Object.assign({}, state, action.response, { warningSubCategories: action.response, loading: false, error: null });
      case LOAD_WARNING_SUB_CATEGORIES_FAIL:
        return Object.assign({}, state, { loading: false, error: action.error, warningSubCategories: undefined });
      case SET_SELECTION:
          return Object.assign({}, state, { selection: action.selection });
      case ACTION:
        return Object.assign({}, state, { loading: true, error: null, progress: action.progress });
      case ACTION_PROGRESS:
        return Object.assign({}, state, { error: null, progress: action.progress });
      case ACTION_OK:
        return Object.assign({}, state, { loading: false, error: null });
      case ACTION_FAIL:
        return Object.assign({}, state, { loading: false, failures: action.failures });
      case LOAD_NODE_WIZARD_NODES_OK:
        return Object.assign({}, state, { nodeWizardNodes: action.response }, { loading: false, error: null });
      case LOAD_NODE_WIZARD_NODES_FAIL:
        return Object.assign({}, state, { asList: undefined, asStructure: undefined, loading: false, error: action.error });
      case CLEAR_ERRORS_AND_WARNINGS:
        return Object.assign({}, state, action.response, { asList: undefined, asStructure: undefined, loading: false, error: null });
      case GET_REOPENABLE_CLOSED_RETURNS_OK:
        return Object.assign({}, state, { reopenableClosedReturns: action.response }, { loading: false, error: null });
      case GET_REOPENABLE_CLOSED_RETURNS_FAIL:
        return Object.assign({}, state, { loading: false, error: action.error });
      case EXPORT_ALL:
          return Object.assign({}, state, { showToast: false, error: null });
      case EXPORT_ALL_OK:
          return Object.assign({}, state, { showToast: true, error: null, exportResponse: action.response });
      case EXPORT_ALL_FAIL:
        return Object.assign({}, state, { showToast: action.showToast, error: action.error, exportResponse: action.showToast ? { isSuccess: false, error: action.error } : state.exportResponse });
      default:
        return state;
    }
  };
  const newState = getNewState(action, state);
  log.debug('updateSubStateFromAction:  newState', newState);
  return newState;
};

function getDisableCheckFromAction(action) {
  switch (action) {
    case ERROR_ACTION_VATRATE:
      return 'DISABLEVATRATECHECK';
    case ERROR_ACTION_VATNR:
      return 'DISABLEECVATNUMBERCHECK';
    case ERROR_ACTION_INVNR:
      return 'DISABLEDOUBLEINVOICENUMBERCHECK';
    case ERROR_ACTION_SUPINVNR:
      return 'DISABLEDOUBLESUPPLIERINVOICENUMBERCHECK';
    case ERROR_ACTION_OSS_VATNR:
      return 'DISABLEOSSVATNUMBERCHECK';
    default:
      return '';
  }
}

function getExportThresholdError(error, languageStrings) {
  const totalCountErrors = error?.data?.errors?.totalCount;
  if (!_.isArray(totalCountErrors) || _.isEmpty(totalCountErrors)) {
    return null;
  }
  const thresholdMatch = totalCountErrors[0]?.match(/must not exceed (\d+)/);
  if (!thresholdMatch) {
    return null;
  }
  const threshold = parseInt(thresholdMatch[1], 10).toLocaleString('en-US');
  return {
    type: 'error',
    message: LANGUAGES_CONTROLLER.formatUtilFormatter(languageStrings, 'errorsAndWarnings_exportThresholdExceeded', [threshold])
  };
}

function getSkippedCount(response = []) {
  response = _.isArray(response) ? response : [response];
  if (!_.isArray(response) || _.isEmpty(response)) {
    return 0;
  }
  let status = _.find(response, (statusDetails) => {
    return statusDetails.statusCode === 200;
  });
  if (_.isEmpty(status) || !_.isArray(status.messages)) {
    return 0;
  }
  return status.messages.length - ErrorsWarningsConfig.MAX_PROCESSING_LIMIT;
}

function getClientFnFromAction(action, params, applyTo = "ids") {
  function unknownAction() {
    const args = arguments;
    // Do this as a promise, so it behaves exactly like the CLIENT actions
    return new Promise((resolve, reject) => {
      log.error('unknownDocumentActionFactory: ', action, args);
      reject(MODULE_NAME + ': Unknown document action: ' + action);
    });
  }

  switch (action) {
    case ERROR_ACTION_MOVE:
      return (value) => {
        let applyToProp = {};
        applyToProp[applyTo] = value;
        let apiParams = {
          applyTo: applyToProp,
          disableCheck: getDisableCheckFromAction(action) || '',
          replaceTagValues: params.replaceTagValues || []
        };
        return CLIENT.doErrorsActionMove(apiParams);
      };

    case ERROR_ACTION_DELETE:
      return (value) => {
        let applyToProp = {};
        applyToProp[applyTo] = value;
        let apiParams = {
          applyTo: applyToProp,
          disableCheck: getDisableCheckFromAction(action) || '',
          replaceTagValues: params.replaceTagValues || []
        };
        return CLIENT.doErrorsActionDelete(apiParams);
      };

    case ERROR_ACTION_VATRATE:
    case ERROR_ACTION_VATNR:
    case ERROR_ACTION_INVNR:
    case ERROR_ACTION_SUPINVNR:
    case ERROR_ACTION_OSS_VATNR:
      return (value) => {
        let applyToProp = {};
        applyToProp[applyTo] = value;
        let apiParams = {
          applyTo: applyToProp,
          disableCheck: getDisableCheckFromAction(action) || '',
          replaceTagValues: params.replaceTagValues || []
        };
        return CLIENT.doErrorsActionDisableCheck(apiParams);
      };

    case ERROR_ACTION_MOVE_WARNING_TO_ERROR:
      return (value) => {
        let applyToProp = {};
        applyToProp[applyTo] = value;
        let apiParams = {
          applyTo: applyToProp
        };
        return CLIENT.doMoveWarningsToError(apiParams);
      };

    case ERROR_ACTION_SAVE_TO_FILE:
      return (value) => {
        if (applyTo === "ids") {
          if (value.length < 1) {
            return null;
          }
          else {
            return CLIENT.getErrorDocument(value[0]);
          }
        }
        return null;
      }
    default:
      return unknownAction;
  }
}

export const API = {
  doLoadErrors: (filterParams,  callback) => {
    return (dispatch, getState) => {
      log.debug('doLoadErrors(): filterParams: ', filterParams);
      dispatch({ type: LOAD_ERRORS });
      return CLIENT.getErrors(filterParams)
        .then((response) => {
          log.debug('doLoadErrors(): success: ', response);
          dispatch({ type: LOAD_ERRORS_OK, response });
          if(callback) {
            callback();
          }
        })
        .catch((error) => {
          log.debug('doLoadErrors(): failure: ', error);
          dispatch({ type: LOAD_ERRORS_FAIL, error });
        });
    };
  },

  doLoadWarnings: (filterParams) => {
    return (dispatch, getState) => {
      log.debug('doLoadWarnings(): filterParams: ', filterParams);
      dispatch({ type: LOAD_WARNINGS });
      return CLIENT.getWarnings(filterParams)
        .then((response) => {
          log.debug('doLoadWarnings(): success: ', response);
          dispatch({ type: LOAD_WARNINGS_OK, response });
        })
        .catch((error) => {
          log.debug('doLoadWarnings(): failure: ', error);
          dispatch({ type: LOAD_WARNINGS_FAIL, error });
        });
    };
  },

  doDownloadErrors: (filterParams, callback = () => { }) => {
    return (dispatch, getState) => {
      log.debug('doDownloadErrors(): filterParams: ', filterParams);
      dispatch({ type: DOWNLOAD_ERRORS });
      return CLIENT.getErrors(filterParams)
        .then((response) => {
          log.debug('doDownloadErrors(): success: ', response);
          let csvData = _.isArray(response) ? response.map(e => ({ 'Invoice Number': e.invoiceNumber, 'Description': e.message })) : [];
          let csv = toCsv(sanitizeCsvData(csvData));
          let blobData = new Blob([csv], { type: 'text/csv;charset=utf-8' });
          let documentName = filterParams.documentName || `ExportedErrorsAndWarnings-${moment.utc(new Date()).format('YYYY-MM-DD')}.csv`;
          FileSaver.saveAs(blobData, documentName);
          dispatch({ type: DOWNLOAD_ERRORS_OK, response: blobData });
          callback(null, csvData);
        })
        .catch((error) => {
          log.debug('doDownloadErrors(): failure: ', error);
          //TODO: Add error messaging
          dispatch({ type: DOWNLOAD_ERRORS_FAIL, error });
          callback(error, null);
        });
    };
  },

  doDownloadWarnings: (filterParams, callback = () => { }) => {
    return (dispatch, getState) => {
      log.debug('doDownloadWarnings(): filterParams: ', filterParams);
      dispatch({ type: DOWNLOAD_WARNINGS });
      return CLIENT.getWarnings(filterParams)
        .then((response) => {
          log.debug('doDownloadWarnings(): success: ', response);
          let csvData = _.isArray(response) ? response.map(e => ({ 'Invoice Number': e.invoiceNumber, 'Description': e.message })) : [];
          let csv = toCsv(sanitizeCsvData(csvData));
          let blobData = new Blob([csv], { type: 'text/csv;charset=utf-8' });
          let documentName = filterParams.documentName || `ExportedErrorsAndWarnings-${moment.utc(new Date()).format('YYYY-MM-DD')}.csv`;
          FileSaver.saveAs(blobData, documentName);
          dispatch({ type: DOWNLOAD_WARNINGS_OK, response: blobData });
          callback(null, csvData);
        })
        .catch((error) => {
          log.debug('doDownloadWarnings(): failure: ', error);
          dispatch({ type: DOWNLOAD_WARNINGS_FAIL, error });
          callback(error, null);
        });
    };
  },

  doUnload: (dataName = '') => {
    return (dispatch, getState) => {
      dispatch({ type: UNLOAD, dataName: dataName });
    };
  },

  doLoadErrorCategories: (filterParams = {}) => {
    return (dispatch, _getState) => {
      log.debug('doLoadErrorCategories(): filterParams: ', filterParams);
      dispatch({ type: LOAD_ERROR_CATEGORIES });
      CLIENT.getErrorCategories(filterParams)
        .then(response => {
          log.debug('doLoadErrorCategories(): response: ', response);
          dispatch({ type: LOAD_ERROR_CATEGORIES_OK, response: response });
        })
        .catch(error => {
          log.debug('doLoadErrorCategories(): error: ', error);
          dispatch({ type: LOAD_ERROR_CATEGORIES_FAIL, error: error });
        });
    };
  },

  doLoadErrorSubCategories: (filterParams = {}, callback = () => { }, loading = true) => {
    return (dispatch, getState) => {
      log.debug('doLoadErrorSubCategories(): filterParams: ', filterParams);
      if (loading) {
        dispatch({ type: LOAD_ERROR_SUB_CATEGORIES });
      }
      log.clearDictionaryError(ALL_MESSAGES.ERRORS_WARNINGS_ACTION_RECORDS_SKIPPED);
      CLIENT.getErrorSubCategories(filterParams)
        .then(response => {
          log.debug('doLoadErrorSubCategories(): response: ', response);
          dispatch({ type: LOAD_ERROR_SUB_CATEGORIES_OK, response: response });
          callback(null, response);
        })
        .catch(error => {
          log.debug('doLoadErrorSubCategories(): error: ', error);
          dispatch({ type: LOAD_ERROR_SUB_CATEGORIES_FAIL, error: error });
          callback(error, null);
        });
    };
  },

  doLoadWarningCategories: (filterParams = {}) => {
    return (dispatch, getState) => {
      log.debug('doLoadWarningCategories(): filterParams: ', filterParams);
      dispatch({ type: LOAD_WARNING_CATEGORIES });
      CLIENT.getWarningCategories(filterParams)
        .then(response => {
          log.debug('doLoadWarningCategories(): response: ', response);
          dispatch({ type: LOAD_WARNING_CATEGORIES_OK, response: response });
        })
        .catch(error => {
          log.debug('doLoadWarningCategories(): error: ', error);
          dispatch({ type: LOAD_WARNING_CATEGORIES_FAIL, error: error });
        });
    };
  },

  doLoadWarningSubCategories: (filterParams = {}, callback = () => { }, loading = true) => {
    return (dispatch, getState) => {
      log.debug('doLoadWarningSubCategories(): filterParams: ', filterParams);
      if (loading) {
        dispatch({ type: LOAD_WARNING_SUB_CATEGORIES });
      }
      log.clearDictionaryError(ALL_MESSAGES.ERRORS_WARNINGS_ACTION_RECORDS_SKIPPED);
      CLIENT.getWarningSubCategories(filterParams)
        .then(response => {
          log.debug('doLoadWarningSubCategories(): response: ', response);
          dispatch({ type: LOAD_WARNING_SUB_CATEGORIES_OK, response: response });
          callback(null, response);
        })
        .catch(error => {
          log.debug('doLoadWarningSubCategories(): Warning: ', error);
          dispatch({ type: LOAD_WARNING_SUB_CATEGORIES_FAIL, error: error });
          callback(error, null);
        });
    };
  },

  doRescheduleCorrection: (errorId, newTransactionDate, successHandler, errorHandler) => {
    return async (dispatch) => {
        dispatch({ type: LOAD });
        try {
            const response = await CLIENT.doRescheduleCorrection(errorId, newTransactionDate);
            dispatch({ type: ACTION_OK });
            successHandler(response);
        } catch (error) {
            dispatch({ type: ACTION_FAIL });
            errorHandler(error);
        }
    };
  },

  doRescheduleCorrectionV3: (errorIds, newTransactionDate, successHandler, errorHandler) => {
    return async (dispatch) => {
      dispatch({ type: LOAD });
      try {
        const response = await CLIENT.doRescheduleCorrectionLatest(errorIds, newTransactionDate);
        dispatch({ type: ACTION_OK });
        successHandler(response);
      } catch (error) {
        dispatch({ type: ACTION_FAIL });
        errorHandler(error);
      }
    };
  },

  doRescheduleNonCorrection: (errorId, newTransactionDate, successHandler, errorHandler) => {
    return async (dispatch) => {
      dispatch({ type: LOAD });
      try {
          const response = await CLIENT.doRescheduleNonCorrection(errorId, newTransactionDate);
          dispatch({ type: ACTION_OK });
          successHandler(response);
      } catch (error) {
          dispatch({ type: ACTION_FAIL });
          errorHandler(error);
      }
    };
  },

  doRescheduleNonCorrectionLatest: (errorIds, newTransactionDate, successHandler, errorHandler) => {
    return async (dispatch) => {
      dispatch({ type: LOAD });
      try {
        const response = await CLIENT.doRescheduleNonCorrectionLatest(errorIds, newTransactionDate);
        dispatch({ type: ACTION_OK });
        successHandler(response);
      } catch (error) {
        dispatch({ type: ACTION_FAIL });
        errorHandler(error);
      }
    };
  },

  doEnterCreditNoteCertificateDate: (errorIds, newTransactionDate, successHandler, errorHandler) => {
    return async (dispatch) => {
      dispatch({ type: LOAD });
      try {
        const response = await CLIENT.doEnterCreditNoteCertificateDate(errorIds, newTransactionDate);
        dispatch({ type: ACTION_OK });
        successHandler(response);
      } catch (error) {
        dispatch({ type: ACTION_FAIL });
        errorHandler(error);
      }
    };
  },

  clearErrorsAndWarnings: () => {
    return (dispatch) => {
      dispatch({ type: CLEAR_ERRORS_AND_WARNINGS });
    };
  },

  doActionOnIds: (action, idList, replaceTagValues, cb) => {
    cb = typeof cb === 'function' ? cb : () => { };
    idList = _.isArray(idList) ? idList : [idList];
    replaceTagValues = _.isArray(replaceTagValues) ? replaceTagValues : [replaceTagValues];
    // Force Ids to be integers, not strings.
    const idsAsInts = idList.map((value) => { return parseInt(value, 10) });
    return (dispatch, getState) => {
      log.debug('doActionOnIds: "%s": ', action, idList);
      log.clearDictionaryError(ALL_MESSAGES.ERRORS_WARNINGS_ACTION_RECORDS_SKIPPED);
      let progressTracker = { total: idList.length, count: 0, successes: [], failures: [] };
      const clientAction = getClientFnFromAction(action, { replaceTagValues: replaceTagValues });
      dispatch({ type: ACTION, progress: progressTracker });
      clientAction(idsAsInts)
        .then(response => {
          log.debug('doActionOnIds: "%s": idList: %s): succeeded: ', action, idList, response);
          log.debug('doActionOnIds succeeded: %s', response.body);
          let skippedCount = getSkippedCount(response);
          if (skippedCount > 0) {
            log.setDictionaryMessage(ALL_MESSAGES.ERRORS_WARNINGS_ACTION_RECORDS_SKIPPED, skippedCount, ErrorsWarningsConfig.MAX_PROCESSING_LIMIT);
          }
          cb(null, response);
          return response;
        })
        .then(
          response => {
            if (action === ERROR_ACTION_SAVE_TO_FILE) {
              if (response.xml) {
                let data = new Blob([response.xml], { type: 'text/plain' });
                FileSaver.saveAs(new Blob([data], { type: "text/plain;charset=utf-8" }), response.documentName || "error.xml");
              }
            }
            return dispatch({ type: ACTION_OK });
          }
        )
        .catch(error => {
          log.debug('doActionOnIds: "%s": documentId: %s):  failed: ', action, idList, error);
          cb(null, error);
          return dispatch({ type: ACTION_FAIL });
        })
    }
  },

  doActionOnFilter: (action, filter, replaceTagValues, cb = () => { }) => {
    replaceTagValues = _.isArray(replaceTagValues) ? replaceTagValues : [replaceTagValues];
    return (dispatch, getState) => {
      log.debug('doActionOnFilter: "%s": ', action, filter);
      log.clearDictionaryError(ALL_MESSAGES.ERRORS_WARNINGS_ACTION_RECORDS_SKIPPED);
      const clientAction = getClientFnFromAction(action, { replaceTagValues: replaceTagValues }, "filter");
      dispatch({ type: ACTION });
      clientAction(filter)
        .then(response => {
          log.debug('doActionOnFilter: "%s": idList: %s): succeeded: ', action, filter, response);
          log.debug('doActionOnFilter succeeded: %s', response.body);
          let skippedCount = getSkippedCount(response);
          if (skippedCount > 0) {
            log.setDictionaryMessage(ALL_MESSAGES.ERRORS_WARNINGS_ACTION_RECORDS_SKIPPED, skippedCount, ErrorsWarningsConfig.MAX_PROCESSING_LIMIT);
          }
          cb(null, response);
          return response;
        })
        .then(
          response => {
            if (action === ERROR_ACTION_SAVE_TO_FILE) {
              if (response.xml) {
                let data = new Blob([response.xml], { type: 'text/plain' });
                FileSaver.saveAs(new Blob([data], { type: "text/plain;charset=utf-8" }), response.documentName || "error.xml");
              }
            }
            return dispatch({ type: ACTION_OK });
          }
        )
        .catch(error => {
          log.debug('doActionOnFilter: "%s": documentId: %s):  failed: ', action, filter, error);
          cb(null, error);
          return dispatch({ type: ACTION_FAIL });
        })
    }
  },

  doLoadNodeWizardNodes: () => {
    log.debug("doLoadNodeWizardNodes()");
    return (dispatch, state) => {
      log.debug('doLoadNodeWizardNodes()');
      dispatch({ type: LOAD });
      return CLIENT.getBulkFindReplaceNodes()
        .then((response) => {
          log.debug('doLoadNodeWizardNodes(): success: ', response);
          dispatch({ type: LOAD_NODE_WIZARD_NODES_OK, response });
        })
        .catch((error) => {
          log.debug('doLoadNodeWizardNodes(): failure: ', error);
          dispatch({ type: LOAD_NODE_WIZARD_NODES_FAIL, error });
        });
    };
  },

  doGetReopenableClosedReturns: () => {
    log.debug("doGetReopenableClosedReturns()");
    const empty = {};
    return (dispatch, state) => {
      dispatch({ type: GET_REOPENABLE_CLOSED_RETURNS_OK, empty });
      log.debug('doGetReopenableClosedReturns()');
      dispatch({ type: LOAD });
      return CLIENT.getReopenableClosedReturns()
        .then((response) => {
          log.debug('doGetReopenableClosedReturns(): success: ', response);
          dispatch({ type: GET_REOPENABLE_CLOSED_RETURNS_OK, response });
        })
        .catch((error) => {
          log.debug('doGetReopenableClosedReturns(): failure: ', error);
          dispatch({ type: GET_REOPENABLE_CLOSED_RETURNS_FAIL, error });
        });
    };
  },

  doReopenClosedReturns: (returnsToOpen, success, partialFailure, failure) => {
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
      const month = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date);
      const day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
      return `${year}-${month}-${day}`;
    };

    const paramsArray = returnsToOpen.map(r => ({
      id: r.id,
      companyId: r.userId,
      country: r.country,
      returnPeriodicity: r.periodicity,
      periodStartDate: formatDate(r.vatReturnStartDate),
      periodEndDate: formatDate(r.vatReturnEndDate),
      filingType: FilingTypeEnum.parseString(r.returnType),
      fileName: r.fileName,
      returnType: 0 // Assuming that the return is not a correction.
    }));

    return async () => {
      log.debug('reopenReturn: params: ', paramsArray);
      const calls = paramsArray.map(params => CLIENT.reopenReturn(params, true));
      Promise.allSettled(calls)
        .then((results) => {
          const failures = results.map((result, index) => result.status !== "fulfilled" ? paramsArray[index] : undefined).filter(result => result !== undefined);
          if (failures.length > 0) {
            if (failures.length === paramsArray.length) {
              failure();
            } else {
              partialFailure();
            }
          } else {
            success();
          }
        });
      }
    },

    doSetSelection: (selection) => (dispatch) => {
      dispatch({ type: SET_SELECTION, selection })
    },

  doExportErrorsWarnings: (params) => {
    return (dispatch, getState) => {
      dispatch({ type: EXPORT_ALL });
      return CLIENT.exportErrorWarningToCSV(params)
          .then((response) => {
              log.debug('doExportErrorsWarnings success');
              dispatch({ type: EXPORT_ALL_OK, response: response});
          })
          .catch((error) => {
              log.debug('doExportErrorsWarnings error');
              const languageStrings = getState().languages?.data || DEFAULT_LANGUAGE_STRINGS;
              const enableErrorsAndWarningsExportV2 = getState().featureFlag?.data?.EnableErrorsAndWarningsExportV2;
              const exportError = getExportThresholdError(error, languageStrings) || {
                type: error.type || 'error',
                message: error.message || 'An error occurred during export'
              };
              dispatch({ type: EXPORT_ALL_FAIL, error: exportError, showToast: enableErrorsAndWarningsExportV2 });
          });
  }
  },

  doExportSelectedErrorsWarnings: (params) => {
    return (dispatch, getState) => {
      dispatch({ type: EXPORT_ALL });
      return CLIENT.exportSelectedErrorWarningToCSV(params)
          .then((response) => {
              log.debug('doExportSelectedErrorsWarnings success');
              dispatch({ type: EXPORT_ALL_OK, response: response});
          })
          .catch((error) => {
              log.debug('doExportSelectedErrorsWarnings error');
              const languageStrings = getState().languages?.data || DEFAULT_LANGUAGE_STRINGS;
              const exportError = getExportThresholdError(error, languageStrings) || {
                type: error.type || 'error',
                message: error.message || 'An error occurred during export'
              };
              dispatch({ type: EXPORT_ALL_FAIL, error: exportError, showToast: true });
          });
    };
  },

  doResetExportAllToast: () => {
    return (dispatch) => {
      dispatch({ type: EXPORT_ALL });
    }
  }
};

export default API;
